<template>
  <section class="container top">
    <div class="left">
      <div class="big_img">
        <img :src="$baseURL + activeImage" width="100%" />
      </div>
      <div class="swiper pro_swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in info.picarrs" :key="index">
            <img :src="$baseURL + item.pic" :key="index" :alt="item.name" width="100%" />
          </div>
        </div>
      </div>
      <div class="iconfont icon-jiantou-copy swiper_prev"></div>
      <div class="iconfont icon-jiantou swiper_next"></div>
    </div>
    <div class="right">
      <h1>
        {{ info.title }} <i>{{ info.sub_title }}</i>
      </h1>
      <div class="item">
        <div class="label">Product Description</div>
        <div class="cont">
          <p>{{ info.remark }}</p>
        </div>
      </div>
      <div class="item">
        <div class="label">Application Cases</div>
        <div class="cont">
          <router-link v-for="item in info.casearr" :key="item.id" :to="{ path: '/case/info', query: { id: item.id } }"
            class="iconfont icon-jiantou">{{ item.title }}</router-link>
        </div>
      </div>
      <router-link :to="{ path: '/countact/ln' }" class="zx iconfont icon-jiantou">Consult us</router-link>
    </div>
  </section>
  <!-- 详细信息 -->
  <section class="container infos">
    <div class="tab">
      <div v-for="(item, index) in infoList" :key="index" :class="{ active: tabActiveIndex == index }"
        @click="tabActiveIndex = index">
        {{ item.tab }}
      </div>
    </div>
    <div v-for="(item, index) in infoList" :key="index" class="rich" v-html="item.rich"
      v-show="tabActiveIndex == index"></div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      activeImage: "",
      swiper: null,

      /* 富文本 */
      infoList: [
        { tab: "product Description", rich: `` },
        { tab: "Product Features", rich: `` },
        { tab: "Technical Parameter", rich: `` },
        { tab: "Product Video", rich: `` },
      ],
      tabActiveIndex: 0,
      info: {},
    };
  },
  methods: {
    /* swiper实例化 */
    onSwiper() {
      let that = this;
      this.swiper = new Swiper(".pro_swiper", {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 11,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper_next",
          prevEl: ".swiper_prev",
        },
        on: {
          slideChange() {
            that.activeImage = that.info.picarrs.pic[this.realIndex];
          },
          click() {
            this.slideTo(this.clickedIndex);
          },
        },
      });
    },
    /* 获取产品信息 */
    async productInfo() {
      let res = await service.productInfo({ id: this.$route.params.id });
      if (res.code == 1) {
        this.info = res.data.productinfo;

        this.infoList[0].rich = res.data.productinfo.content;
        this.infoList[1].rich = res.data.productinfo.pro_trait;
        this.infoList[2].rich = res.data.productinfo.pro_tec;
        this.infoList[3].rich = res.data.productinfo.pro_video;

        this.infoList.forEach(_ => {
          // _.rich = _.rich.split(`src="`).join(`src="${this.$baseURL}`);

          let as = _.rich.split(`src="`);

          as.forEach((item, index) => {
            if (index && !item.split("http")) item = this.$baseURL + item;
          });

          _.rich = as.join(`src="`);
        });

        this.activeImage = this.info.picarrs[0].pic;
      }
    },
  },
  mounted() {
    this.productInfo();
  },
  watch: {
    info() {
      this.$nextTick(() => {
        this.onSwiper();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  display: flex;

  .left {
    width: 50%;
    margin-right: 60px;
    position: relative;

    .big_img {
      background: #f6f6f8;

      img {
        width: 100%;
      }
    }

    .swiper {
      width: 92%;
      margin: 20px auto 0;
      box-sizing: border-box;

      .swiper-slide {
        background: #f6f6f8;

        img {
          width: 100%;
        }
      }
    }

    .swiper_prev,
    .swiper_next {
      position: absolute;
      bottom: 6%;
      z-index: 2;
      color: var(--themeColor);
      cursor: pointer;
    }

    .swiper_prev {
      left: -10px;
    }

    .swiper_next {
      right: -10px;
    }
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h1 {
      font-size: 30px;

      i {
        font-weight: 400;
        margin-left: 10px;
      }
    }

    .item {
      width: 100%;
      margin: 20px auto;

      .label {
        width: max-content;
        background: var(--themeColor);
        color: #fff;
        font-size: 18px;
        padding: 8px 20px;
        border-radius: 10px 10px 0 0;
      }

      .cont {
        border-top: 1px solid #ddd;
        padding-top: 20px;
        display: flex;
        justify-content: space-between;

        p {
          color: #999999;
          line-height: 2;
        }

        a {
          display: flex;
          flex-direction: row-reverse;
          font-family: Regular !important;
          color: #333;
          font-size: 14px;

          &::before {
            font-family: iconfont !important;
            margin-left: 10px;
          }
        }
      }
    }

    .zx {
      background: var(--themeColor);
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row-reverse;
      line-height: 4;
      font-size: 18px;
      border-radius: 8px;
      font-family: Regular !important;

      &::before {
        font-family: iconfont !important;
        margin-left: 20px;
      }
    }
  }
}

.infos {
  border-top: 1px solid #ddd;

  .tab {
    display: flex;
    margin-bottom: 20px;

    div {
      padding: 20px 20px 0;
      line-height: 1;
      font-size: 18px;
      color: #666;
      border-top: 3px solid transparent;
      position: relative;
      cursor: pointer;

      &::after {
        content: "";
        width: 1px;
        height: 1em;
        background: #ddd;
        position: absolute;
        left: 0;
        bottom: 0;
      }

      &.active {
        color: var(--themeColor);
        font-weight: bold;
        border-color: var(--themeColor);
      }
    }
  }
}

@media (max-width: 700px) {
  .top {
    display: block;

    .left {
      width: 100%;
      margin-left: 0;
    }
  }
}
</style>